import { useContext } from 'react'
import { ThemeContext } from 'styled-components'

import { defaultTheme } from './default-theme'

export const useTheme = () => {
  const theme: typeof defaultTheme = useContext(ThemeContext)
  return theme ? theme : defaultTheme
}
